/**
 * Arthaus Frame Switcher
 * Phase: 4 (refactor)
 *
 * Upgrades the Framed | Print Only toggle (snippets/frame-switcher.liquid)
 * from plain navigation into an in-place, no-reload product swap using the
 * Shopify Section Rendering API:
 *
 *     GET /products/<handle>?section_id=<product-hero section id>
 *
 * The returned markup is the rendered product-hero section for the counterpart
 * product (its own gallery, options, price and switcher). We splice the
 * [data-product-hero] contents into the current page, re-init the PDP module,
 * and push the counterpart URL so the address bar + back/forward stay correct.
 *
 * Depends on window.ArthausPDP (assets/product-config.js) — loaded first.
 * Falls back to a normal navigation if anything goes wrong (the toggle is a
 * real <a href>, so no-JS / error paths still work).
 */
(function () {
  'use strict';

  var cache = {};

  function getHero() {
    return document.querySelector('[data-product-hero]');
  }

  function heroSectionId() {
    var hero = getHero();
    if (!hero) return null;
    var section = hero.closest('.shopify-section');
    if (!section || !section.id) return null;
    return section.id.replace(/^shopify-section-/, '');
  }

  function handleFromPath(path) {
    var m = (path || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function currentHandle() {
    var hero = getHero();
    var active = hero && hero.querySelector('[data-frame-tab][aria-selected="true"]');
    return active ? active.getAttribute('data-handle') : null;
  }

  function setLoading(on) {
    var sw = document.querySelector('[data-frame-switcher]');
    if (sw) sw.setAttribute('aria-busy', on ? 'true' : 'false');
    var hero = getHero();
    if (hero) hero.style.opacity = on ? '0.55' : '';
  }

  function fetchSection(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var sid = heroSectionId();
    if (!sid) return Promise.reject(new Error('no section id'));
    return fetch('/products/' + handle + '?section_id=' + encodeURIComponent(sid))
      .then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); })
      .then(function (html) { cache[handle] = html; return html; });
  }

  function swapTo(handle, url, options) {
    options = options || {};
    var hero = getHero();
    if (!hero || !handle) { window.location.href = url; return; }

    setLoading(true);
    fetchSection(handle)
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newHero = doc.querySelector('[data-product-hero]');
        if (!newHero) throw new Error('no hero in response');

        hero.innerHTML = newHero.innerHTML;

        var newTitle = doc.querySelector('[data-product-config] h1');
        if (newTitle) document.title = newTitle.textContent.trim();

        if (window.ArthausPDP && window.ArthausPDP.init) window.ArthausPDP.init(hero);
        bindSwitcher();

        if (!options.skipPush) {
          history.pushState({ frameSwap: true, handle: handle }, '', url);
        }
        setLoading(false);
      })
      .catch(function () {
        // Robust fallback: just navigate.
        window.location.href = url;
      });
  }

  function bindSwitcher() {
    var sw = document.querySelector('[data-frame-switcher]');
    if (!sw) return;
    var mode = sw.getAttribute('data-current-mode');
    sw.querySelectorAll('[data-frame-tab]').forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        // Allow new-tab / modified clicks to behave normally.
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        if (tab.getAttribute('data-frame-tab') === mode) return; // already active
        swapTo(tab.getAttribute('data-handle'), tab.getAttribute('href'));
      });
    });
  }

  window.addEventListener('popstate', function () {
    var handle = handleFromPath(window.location.pathname);
    if (!handle) return;
    if (handle !== currentHandle()) {
      swapTo(handle, window.location.pathname, { skipPush: true });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSwitcher);
  } else {
    bindSwitcher();
  }
})();
